module.exports = "/img/filterTask.b3882a38.gif";